import { Box, Button, Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import sloth from '../../../assets/sloth.svg';

type Props = {
    onReset: () => void;
};

export const ErrorBoundaryFallback = ({ onReset }: Props): JSX.Element => {
    const { formatMessage } = useIntl();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                gap: 2,
                padding: 4,
            }}
            data-testid="error-boundary-fallback"
        >
            <img src={sloth} alt="" width={120} height={120} />
            <Typography variant="h2">
                {formatMessage({ id: 'global.error.please_retry' })}
            </Typography>
            <Button variant="contained" onClick={onReset} data-testid="error-boundary-retry">
                {formatMessage({ id: 'global.refresh' })}
            </Button>
        </Box>
    );
};
